export default class LocalStorage {
    constructor(Wheel) {
        this.prefix = 'w' + Wheel.id + '_';
        this.clearExpired();
    }

    set(name, value, exdays = 7) {
        const d = new Date();
        const cname = this.prefix + name;
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        localStorage.setItem(cname, JSON.stringify({
            exp: d,
            value: value
        }))
    }

    get(name) {
        const cname = this.prefix + name;
        const str = localStorage.getItem(cname);
        if (!str) return null;
        const wrap = JSON.parse(str);
        if (!wrap.exp || new Date(wrap.exp) < new Date()) {
            localStorage.removeItem(cname);
            return null;
        }
        return wrap.value;
    }

    clearExpired() {
        //TODO: implement
        const keys = Object.keys(localStorage);
        for (let key of keys) {
            const str = localStorage.getItem(key);
            try {
                const wrap = JSON.parse(str);
                if (!wrap.exp || new Date(wrap.exp) < new Date()) {
                    localStorage.removeItem(key);
                }
            } catch (e) {

            }
        }
        return false;
    }

    remove(name) {
        const cname = this.prefix + name;
        localStorage.removeItem(cname);
    }
}